import styled from "styled-components"

import globalStyles from "@data/globalStyles"

function PortraitPrompt() {
	return (
		<Wrapper>
			PLEASE USE ON <br />
			PORTRAIT MODE
		</Wrapper>
	)
}

export default PortraitPrompt

const Wrapper = styled.div`
	position: absolute;
	z-index: 9999999;
	top: 0%;
	width: 100%;
	height: 100%;
	background-color: ${globalStyles.colors.main};
	color: ${globalStyles.colors.secondary};
	text-align: center;
	font-size: 8rem;
	font-family: title;
	display: none;

	@media (max-width: 900px) and (orientation: landscape) {
		display: grid;
		place-content: center;
	}
`
